export function lrem(key, c, value) {
  if (this.data.has(key) && !(this.data.get(key) instanceof Array)) {
    return 0
  }
  const count = parseInt(c, 10)
  const list = [...(this.data.get(key) || [])]
  const indexFun = count < 0 ? 'lastIndexOf' : 'indexOf'
  const max = count === 0 ? list.length : Math.abs(count)
  let removed = 0
  let idx = list[indexFun](value)
  while (idx !== -1 && removed < max) {
    removed++
    list.splice(idx, 1)
    idx = list[indexFun](value)
  }
  this.data.set(key, list)
  return removed
}

export const lremBuffer = lrem
